import { Link as RouterLink } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import {
  Grid,
  Link,
  Divider,
  Container,
  Typography,
  Stack,
} from "@mui/material";
// routes
import { PATH_PAGE } from "../../routes/paths";
// components
import Logo from "../../components/Logo";
import SocialsButton from "../../components/SocialsButton";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import moment from "moment";
import shakeHand from "./shakeHand.png";
import useResponsive from "src/hooks/useResponsive";

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: "Contact Info",
    children: [
      {
        icon: <LocationOnIcon fontSize="small" color="primary" />,
        name: "Level 4, Belfort Tower, Cnr Dauphine St & Dr Joseph Riviere St, Port Louis, MU",
        href: "#",
      },
      {
        icon: <PhoneIcon fontSize="small" color="primary" />,
        name: "+230 218 3030",
        href: "#",
      },
      {
        icon: <EmailIcon fontSize="small" color="primary" />,
        name: "info@aarmando.com",
        href: "#",
      },
    ],
  },
  {
    headline: "Services",
    children: [
      {
        icon: <ArrowRightIcon fontSize="small" color="primary" />,
        name: "Accounting Services",
        href: "/services",
      },
      {
        icon: <ArrowRightIcon fontSize="small" color="primary" />,
        name: "Tax Services",
        href: "/services",
      },
      {
        icon: <ArrowRightIcon fontSize="small" color="primary" />,
        name: "Payroll",
        href: "/services",
      },
      {
        icon: <ArrowRightIcon fontSize="small" color="primary" />,
        name: "Back Office",
        href: "/services",
      },
      {
        icon: <ArrowRightIcon fontSize="small" color="primary" />,
        name: "Advisory & Consultancy",
        href: "/services",
      },
      {
        icon: <ArrowRightIcon fontSize="small" color="primary" />,
        name: "Statutory filings",
        href: "/services",
      },

      {
        icon: <ArrowRightIcon fontSize="small" color="primary" />,
        name: "Company secretary",
        href: "/services",
      },
      {
        icon: <ArrowRightIcon fontSize="small" color="primary" />,
        name: "IPR Services",
        href: "/services",
      },
      {
        icon: <ArrowRightIcon fontSize="small" color="primary" />,
        name: "Licenses and permits",
        href: "/services",
      },
    ],
  },
  {
    headline: "Get In Touch",
    children: [
      {
        icon: <ArrowRightIcon fontSize="small" color="primary" />,
        name: "Connect with out experts for tailored financial solutions",
        href: "#",
      },
    ],

    followIcon: true,
  },
];

const RootStyle = styled("div")(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.background.default,
  width: "100%",
  backgroundImage: `linear-gradient(rgba(57, 3, 40, 0.7), rgba(57, 3, 40, 0.7)), url('${shakeHand}')`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  const isDesktop = useResponsive("up", "md");

  return (
    <RootStyle>
      <Divider />
      <Container sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{ xs: "center", md: "space-between" }}
          sx={{ textAlign: { xs: "center", md: "left" } }}
        >
          <Grid item xs={12} md={4} sx={{ mb: 3 }}>
            <Logo
              sx={{
                mx: { xs: "auto", md: "inherit" },
                width: "100px",
                height: "auto",
              }}
            />
            <br />
            <Typography
              variant="body1"
              sx={{ /* pr: { md: 5 }, */ color: "#fff" }}
            >
              Aarmando Group, a company licensed by the Mauritius Institute of
              Professional Accountants (MIPA) as a Member Firm of Chartered
              Certified Accountants
            </Typography>
          </Grid>
          {/* <Grid item xs={8} md={4}>
            <Stack
              direction="row"
              justifyContent={{ xs: "center", md: "flex-start" }}
              sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
            >
              <SocialsButton sx={{ mx: 0.5 }} />
            </Stack>
          </Grid> */}

          <Grid item xs={12} md={8}>
            <Stack
              spacing={5}
              direction={{ xs: "column", md: "row" }}
              justifyContent="space-between"
              style={{ flexWrap: "wrap", overflowX: "hidden" }}
            >
              <Grid container spacing={3}>
                {LINKS.map((list) => (
                  <Grid item xs={12} md={4}>
                    <Stack key={list.headline} spacing={1}>
                      <Typography component="p" variant="h5" color={"primary"}>
                        {list.headline}
                      </Typography>
                      <br />

                      {list.children.map((link) => (
                        <Stack
                          direction={"row"}
                          alignItems={"flex-start"}
                          spacing={1}
                        >
                          {link.icon}
                          <Link
                            to={link.href}
                            key={link.name}
                            color="inherit"
                            variant="body2"
                            component={RouterLink}
                            sx={{ display: "block", color: "#fff" }}
                          >
                            {link.name}
                          </Link>
                        </Stack>
                      ))}
                    </Stack>
                    {list?.followIcon ? (
                      <>
                        <Stack
                          direction="row"
                          justifyContent={{ xs: "center", md: "flex-start" }}
                          sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
                        >
                          <SocialsButton /*  sx={{ mx: 0.5 }} */ />
                        </Stack>
                      </>
                    ) : (
                      <></>
                    )}
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          {`© ${moment(new Date()).format("YYYY")} . All rights reserved`}
        </Typography>
      </Container>
    </RootStyle>
  );
}
